export enum ReportType {
  TRACKING = "tracking",
}

export enum ReportStatus {
  QUEUED = "QUEUED",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED"
}

export const TERMINAL_REPORT_STATUSES: ReportStatus[] = [
  ReportStatus.COMPLETED,
  ReportStatus.FAILED,
  ReportStatus.CANCELLED,
  ReportStatus.EXPIRED,
];

export interface IReportError {
  error: true;
  message: string;
}

export interface IReportRequest<T> {
  id: string;
  deviceEsns: string[];
  status: ReportStatus;
  startDate: string;
  endDate: string;
  data?: T[] | IReportError;
  createdAt: string;
}

export interface TelematicStartStopEvent {
  deviceEsn: string;
  numOfJourneys: number;
  totalDuration: number;
  totalMiles: number;
  totalIdleTime: number;
  journeys: TelematicStartStopEventJourney[];
}

export interface TelematicStartStopEventJourney {
  startStreet?: string;
  endStreet?: string;
  sTime: string;
  eTime: string;
  duration: number;
  idleTime: number;
  miles: number;
  startLat: number;
  startLong: number;
  endLat: number;
  endLong: number;
  maxSpeed: number;
  avgSpeed: number;
  fuelConsumed: number | null;
  odometer: number;
  harshBraking: number;
  harshAcceleration: number;
  hardCornering: number;
  speeding: number;
  lostGPS: number;
  lostGSM: number;
  tripEventDetails: ITelematicsData;
}

export interface ITelematicsData {
  milesDriven: string;
  engineHours: string;
  fuelUsage: string;
  stoppageHours: string;
  mapFlagsData: IMapFlagsData;
  mapRoutesData: IMapRouteData;
  tripTimesData: {
    tripStart: string[];
    tripEnd: string[];
  };
}

export interface IMapFlagsData {
  eventTime: string[];
  speedlimit: string[];
  magnitude: string[];
  Key: string[];
  latlong: string[];
}

export interface IMapRouteData {
  eventTime: string[];
  latlong: string[];
}

export interface ITrackingReportVehicle {
  id: string;
  licencePlate: string;
  make?: string | null;
  model?: string | null;
  telemetryDeviceId?: string | null;
  isGhostVehicle?: boolean | null;
  branchId?: string | null;
}
